import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useLocation, useLink } from '@grandvisionhq/frk-routing';
import { createSlotsContext } from '@grandvisionhq/slots';
import { useSelector, useFeatureToggles } from '@grandvisionhq/state';
import { useGetQueryParams, appendQueryParamToUrl } from '@grandvisionhq/utils';
import { getOrderShippingData, isCompleted } from '../../selectors.js';
import { ShippingObjectTypes } from '../../state.js';
import { getSelectedShippingMethod, getShippingData } from '../../StepShipping/selectors.js';
import { ShippingSummarySlotTypes } from './types.js';
import { isPickupStore, isPickupPoint } from '../../utils/shipping-method.js';

const [SummarySlotsProvider, useBaseSummarySlot] = createSlotsContext({
    displayName: 'SummarySlotsContext'
});
const useSummariesSlot = (isEditable = false)=>{
    var ref;
    const { cartId , cartHash  } = useGetQueryParams();
    const { push  } = useLocation();
    const selectedShippingMethod = (ref = useSelector(getSelectedShippingMethod)) === null || ref === void 0 ? void 0 : ref.method;
    const isPickup = isPickupStore(selectedShippingMethod) || isPickupPoint(selectedShippingMethod);
    const { Slots  } = useBaseSummarySlot();
    const { isPaymentCallbackApiRouteEnabled  } = useFeatureToggles();
    const shippingData = useSelector(getShippingData);
    const orderShippingData = useSelector(getOrderShippingData);
    const isCheckoutCompleted = useSelector(isCompleted);
    const slotShippingData = (isPaymentCallbackApiRouteEnabled || isCheckoutCompleted) && orderShippingData ? orderShippingData : shippingData;
    const { href: shippingPageHref  } = useLink({
        route: 'checkout.shipping'
    }) || {};
    const goToShippingStep = React__default.useCallback(()=>shippingPageHref && push(appendQueryParamToUrl(shippingPageHref, swcHelpers.objectSpread({}, typeof cartId === 'string' ? {
            cartId
        } : {}, typeof cartHash === 'string' ? {
            cartHash
        } : {})))
    , [
        shippingPageHref,
        push,
        cartId,
        cartHash
    ]);
    const onEdit = React__default.useCallback(()=>{
        goToShippingStep === null || goToShippingStep === void 0 ? void 0 : goToShippingStep();
    }, [
        goToShippingStep
    ]);
    /**
   *  Iterate over all summary components passed by opco
   *  Bind data to summary component
   **/ const actions = {
        onEdit
    };
    const summaries = Object.entries(Slots).reduce((summaryItem, [key, Slot])=>{
        let summaryData = slotShippingData && slotShippingData[key];
        if (shippingData && key === ShippingObjectTypes.ContactDetails) {
            const { firstName , lastName  } = shippingData[ShippingObjectTypes.BillingAddress];
            summaryData = swcHelpers.objectSpread({
                firstName,
                lastName
            }, summaryData);
        }
        // If DeliveryAddress has no summaryData, which means DeliveryAddress is the same as BillingAddress
        // Set summaryData for DeliveryAddress to summaryData of BillingAddress
        if (key === ShippingSummarySlotTypes.Addresses) {
            summaryData = {};
            summaryData.billingAddress = slotShippingData === null || slotShippingData === void 0 ? void 0 : slotShippingData.billingAddress;
            summaryData.deliveryAddress = slotShippingData === null || slotShippingData === void 0 ? void 0 : slotShippingData.deliveryAddress;
            if (!(slotShippingData === null || slotShippingData === void 0 ? void 0 : slotShippingData.deliveryAddress)) {
                summaryData.isAddressesEqual = true;
            } else {
                summaryData.isAddressesEqual = false;
            }
            if (isPickup) {
                summaryData.isPickupOrder = true;
            } else {
                summaryData.isPickupOrder = false;
            }
        }
        summaryItem[key] = /*#__PURE__*/ React__default.createElement(Slot, {
            "data-t": `${key}Summary`,
            actions: isEditable ? actions : undefined,
            values: summaryData
        });
        return summaryItem;
    }, {});
    return summaries;
};

export { SummarySlotsProvider, useBaseSummarySlot, useSummariesSlot };
//# sourceMappingURL=summary-context.js.map
